import { IEmployee } from "api/querries/useGetEmployees"

import { Text } from "@chakra-ui/react"
import SelectInput from "components/UI/atoms/Select/Select"
import { ISelectOption } from "types/shared"

const generateOptions = (quantity: number) => {
  const options: ISelectOption[] = []

  for (let i = 1; i <= quantity; i++) {
    options.push({ label: `#${i}`, value: i.toString() })
  }

  options.unshift({ label: "No Box", value: "0" })

  return options
}

export const
  getColumns = (t: any, { updateEmployee }: any): any => [
    {
      key: "employees.table.columns.fullname",
      label: t("employees.table.columns.fullname"),
      render: (data: IEmployee) => <Text>{data.fullName}</Text>,
      hasClick: true,
    },
    {
      key: "employees.table.columns.personal_code",
      label: t("employees.table.columns.personal_code"),
      render: (data: IEmployee) => <Text>{data.personalCode}</Text>,
      hasClick: true,
    },
    {
      key: "employees.table.columns.role",
      label: t("employees.table.columns.role"),
      render: (data: IEmployee) => <Text>{t(`employees.positions.${data.roleName}`)}</Text>,
      hasClick: true,
    },
    {
      key: "employees.table.columns.phone",
      label: t("employees.table.columns.phone"),
      render: (data: IEmployee) => <Text>{data.phoneNumber}</Text>,
      hasClick: true,
    },
    {
      key: "employees.table.columns.box",
      label: t("employees.table.columns.box"),
      render: (data: IEmployee) => (
        <SelectInput
          styles={{
            option: (baseStyles: any) => ({
              ...baseStyles,
              fontSize: "12px",

            }),
          }}
          value={data.box?.toString()}
          onChange={(e: ISelectOption) => updateEmployee({ ...data, phoneNumber: data.phoneNumber || "", box: e.value })}
          options={data.carWashBoxCount ? generateOptions(data?.carWashBoxCount) : []}
          isDisabled={data.carWashBoxCount === null || data.carWashBoxCount === 0 || data.roleName !== "Washer"}
          inputStyles={{ width: "75px" }}

        />
      ),
      hasClick: false,
      styles: {
        width: 100,
      },
    },
  ]

